var file = {
    picker: (id) => {
        const el = document.getElementById(id);
        if (el) {
            el.click();
        }
    }
}